import React from "react"
import { useTranslation } from "react-i18next"

import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import {
  InstallationReferenceSelection,
  InstallationReferenceSelectionModel
} from "widgets/installation-reference-selection/InstallationReferenceSelection"

import "./styles/_installation-reference-selection-overlay.scss"

export interface InstallationReferenceSelectionOverlayViewModel {
  installationReferenceSelectionModel: InstallationReferenceSelectionModel
  closeOverlay: () => void
}

export const InstallationReferenceSelectionOverlayView = React.memo(
  ({
    installationReferenceSelectionModel,
    closeOverlay
  }: InstallationReferenceSelectionOverlayViewModel) => {
    const { t } = useTranslation()

    return (
      <FormOverlay
        id="installation-reference-selection-overlay"
        form="installation-reference-selection"
        headline={t("InstallationReference.SelectInstallationReferences")}
        onCancel={closeOverlay}
        className="installation-reference-selection-overlay"
        showCloseButton
      >
        <InstallationReferenceSelection
          {...installationReferenceSelectionModel}
        />
      </FormOverlay>
    )
  }
)
